
import { Users } from "lucide-react";
import { EmptyState } from "../EmptyState";

const EmptyCollaboratorsList = () => {
  return (
    <EmptyState
      icon={Users}
      title="No collaborators yet"
      description="Start collaborating by inviting team members using the Invite button above."
    />
  );
};

export default EmptyCollaboratorsList;
